/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentParcelEnumsViewModel } from "../types/IndividualPaymentParcelEnumsViewModel.ts";
import { dropDownListViewModelSchema } from "./dropDownListViewModelSchema.ts";

export const individualPaymentParcelEnumsViewModelSchema = z.object({
  types: z.array(z.lazy(() => dropDownListViewModelSchema)).nullish(),
  statuses: z.array(z.lazy(() => dropDownListViewModelSchema)).nullish(),
  gridStatuses: z.array(z.lazy(() => dropDownListViewModelSchema)).nullish(),
  paymentMethods: z.array(z.lazy(() => dropDownListViewModelSchema)).nullish(),
  invoiceStatuses: z.array(z.lazy(() => dropDownListViewModelSchema)).nullish(),
  transferTypes: z.array(z.lazy(() => dropDownListViewModelSchema)).nullish(),
}) as unknown as ToZod<IndividualPaymentParcelEnumsViewModel>;
